import React from 'react';
import Reflux from 'reflux';
import {Link} from 'react-router-dom';
import './TopicItem.css';
import axios from 'axios';
import RcIf from 'rc-if';
export default class TopicItem extends Reflux.Component {
    constructor (props) {
        super(props);
        this.state = {
            topicTitle: props.topicTitle,
            topicActivity: {
                creations: 0,
                relatedOptions: 0
            }
        };
        this.getTopicActivity(props.topicTitle);
    }
    componentWillReceiveProps (nextProps) {
        if (nextProps.topicTitle === this.state.topicTitle) {
            return;
        }
        this.setState({topicTitle: nextProps.topicTitle});
        this.getTopicActivity(nextProps.topicTitle);
    }
    getTopicActivity =(topicTitle) => {
        return axios.get(`${process.env.REACT_APP_API_URL}/api/topics/activity/${topicTitle}`)
        .then((results) => {
            this.setState({topicActivity: {
                creations: results.data.creations,
                relatedOptions: results.data.relatedOptions
            }});
        });
    }
    render () {
        return (
          <RcIf if={this.props.topicTitle && true}>
            <li className='TopicItem'>
              <div className='top_box_topic'>
                <h6>Tópico</h6>
                <div className='icon_category'><img src='/images/icons/topico.svg' /></div>
              </div>
              <div className='name_topic center-align'>
                <Link to={'/topic/g_' + this.props.topicTitle.replace(/ /g, '-')}>
                  <h5>{this.props.topicTitle}</h5>
                </Link>
              </div>
              <div className='bottom_topic'>
                <div>
                  <span>{this.state.topicActivity.creations || 0}</span>Participaciones</div>
                <div>
                  <span>{this.state.topicActivity.relatedOptions || 0}</span>Opciones Elegidas</div>
              </div>
            </li>
          </RcIf>
        );
    }
}



// WEBPACK FOOTER //
// ./src/sections/ItemTopic.js